import { Component, Input } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { FileDownloadService } from '../../../services/file-download.service';

@Component({
  selector: 'app-download-template',
  standalone: true,
  imports: [ButtonModule],
  templateUrl: './download-template.component.html',
  styleUrl: './download-template.component.scss',
})
export class DownloadTemplateComponent {
  @Input() disabled = false;
  @Input() label = 'Vorlage herunterladen';
  @Input() type!: 'indicators' | 'data' | 'poi';

  constructor(private fileDownloadService: FileDownloadService) {}

  baseTemplatePath = '/assets/xlsx/';

  templateUrls: { [key: string]: string } = {
    indicators: 'Importvorlage_Indikatoren.xlsx',
    data: 'Importvorlage_Indikatorendaten.xlsx',
    poi: 'Importvorlage_POI.xlsx',
  };

  /**
   * Retrieves the complete download URL for the specified template type.
   *
   * The method constructs the URL by combining the base template path
   * with the specific template URL associated with the current type.
   *
   * @return {string} The full download URL for the selected template.
   */
  get downloadUrl(): string {
    return `${this.baseTemplatePath}${this.templateUrls[this.type]}`;
  }

  /**
   * Initiates the download of a template file corresponding to a specific type.
   * Uses the file download service to fetch and save the file locally.
   * Logs a success message upon successful download completion.
   *
   * @return {void} This method does not return a value.
   */
  downloadTemplate(): void {
    this.fileDownloadService
      .downloadFile(this.downloadUrl, this.templateUrls[this.type], true)
      .subscribe(() => {
        console.log('File downloaded successfully!');
      });
  }
}
